/* unplugin-vue-components disabled */import script from "./SideMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenu.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenu.vue?vue&type=style&index=0&id=5d5d73a0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5d73a0"]])

export default __exports__